import React, { useRef, useState, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useSelector, useDispatch } from 'react-redux'
import { Modal, Button } from 'react-bootstrap';
import { WEBHRIS_OLD, WEBHRIS_OLD_LOGIN_URL, URL_ROOT } from '../../../../config/settings'
import { logoutUser } from '../../../containers/Login/state/operations'

const IdleTimerContainer = () => {
    const dispatch = useDispatch()
    const creds = useSelector(({ auth }) => auth.credentials)
    const isAuthenticated = useSelector(({ auth }) => auth.isAuthenticated)
    const isPublicAuthenticated = useSelector(({ auth }) => auth.isPublicAuthenticated)
    const timeout = 1000 * 60 * 5 // 5 minutes
    const [remaining, setRemaining] = useState(timeout)
    const [elapsed, setElapsed] = useState(0)
    const [lastActive, setLastActive] = useState(+new Date())
    const [isIdle, setIsIdle] = useState(false)
    const [showModal, setShow] = useState(false);
    const idleTimerRef = useRef(null);
    // handle show modal and countdown 1minute then automatic logout
    const sessionTimeoutRef = useRef(null)
    const publicData = JSON.parse(localStorage.getItem('publicLoginData'))

    // handles if user is active
    // const handleOnActive = () => {
    //     setIsIdle(false)
    //     setShow(false)
    //     console.log(creds.userFullname, ' is active')
    // }

    // handle if user is idle
    const handleOnIdle = () => {
        if (isAuthenticated) {
            setIsIdle(true)
            setShow(true)
            console.log(creds.userFullname, ' is idle')
            sessionTimeoutRef.current = setTimeout(logOut, 1000 * 60)
        }
        else if (isPublicAuthenticated) {
            setIsIdle(true)
            setShow(true)
            sessionTimeoutRef.current = setTimeout(logOut, 1000 * 60)
        }
    }

    const logOut = (e) => {
        if (isAuthenticated) {
            setShow(false)
            clearTimeout(sessionTimeoutRef.current)
            dispatch(logoutUser())
            window.location.replace(WEBHRIS_OLD_LOGIN_URL + "?redirect=hrrec");
        }
        else if (isPublicAuthenticated) {
            setShow(false)
            clearTimeout(sessionTimeoutRef.current)
            localStorage.removeItem('publicLoginData')
            window.location.replace(URL_ROOT + `/apply`)
        }
    }

    const stayActive = () => {
        setShow(false)
        clearTimeout(sessionTimeoutRef.current)
    }

    const {
        getRemainingTime,
        getLastActiveTime,
        getElapsedTime
    } = useIdleTimer({
        timeout,
        // onActive: handleOnActive,
        onIdle: handleOnIdle,
        ref: { idleTimerRef }
    })

    useEffect(() => {
        setRemaining(getRemainingTime())
        setLastActive(getLastActiveTime())
        setElapsed(getElapsedTime())

        setInterval(() => {
            setRemaining(getRemainingTime())
            setLastActive(getLastActiveTime())
            setElapsed(getElapsedTime())
        }, 1000)
    }, [])

    return (
        <Modal centered={false}
            show={showModal}
            size='md'
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>
                    You have been inactive for awhile.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Your session will automatically logout if there is no activity within 1 minute.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' data-dismiss='modal' onClick={logOut}>Logout</Button>
                <Button variant='primary' onClick={stayActive}>Keep me signed in</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default IdleTimerContainer;
